<template>
  <div class="box">
    <check-login-and-invest :confirmText="confirmText"/>
    <check-real-name-and-risk :showModalInfo="showModalInfo"/>
  </div>
</template>

<script>

import {
  fetchGetLastRiskAnswer,
} from './fundApi'; // 导入默认导出的函数
import { asyncIsNeedPop } from './investors-trace';
import CheckLoginAndInvest from './CheckLoginAndInvest.vue';
import CheckRealNameAndRisk from './CheckRealNameAndRisk.vue';

export default {
  name: 'HighEndCheck',
  components: { CheckLoginAndInvest, CheckRealNameAndRisk },
  props: {
    fundCode: String,
  },
  data() {
    return {
      isLogin: false, // 是否登录
      isRealName: false, // 是否实名
      isPassRisk: false, // 是否通过风险测评
      isClickedInvestorPop: false, // 是否点击过投资者类型弹窗
      showModalInfo: {}, // 自定义modal显示信息
      confirmText: '',
    };
  },

  created() {
    // multi.$on.backAppear(() => {
    //   console.log('yyz----backAppear');
    //   this.initCheck();
    // });
  },

  mounted() {
    // this.initCheck();
  },

  methods: {
    // 按顺序检查 未登录 -> 未实名 -> 未通过风险测评 -> 未点击投资者类型弹窗
    async initCheck() {
      this.isLogin = await this.checkLogin();
      if (!this.isLogin) return;

      this.isRealName = await this.checkRealName();
      if (!this.isRealName) return;

      this.isPassRisk = await this.checkPassRisk();
      if (!this.isPassRisk) return;

      this.isClickedInvestorPop = await this.checkClickedInvestorPop();
    },

    // 检查是否登录
    async checkLogin() {
      const userInfo = window.highEndInfo || {};
      console.log('userInfo===', userInfo);
      const {
        uid,
      } = userInfo;
      if (!uid) {
        //   登录弹窗
        this.confirmText = '登录查看';
      } else {
        this.confirmText = '';
      }
      return !(!uid);
    },

    // 检查是否实名
    async checkRealName() {
      const userInfo = window.highEndInfo || {};
      console.log('userInfo===', userInfo);
      const {
        isvisitor,
      } = userInfo;
      const res = (isvisitor === '0');
      // try {
      //   // 动态参数
      //   const dynamicParams = {
      //     FundCode: this.fundCode, // 示例动态参数
      //   };
      //   const response = await fetchRiskMatchData(dynamicParams);
      //   res = !(response?.Data?.IsVisitor);
      //   highCache.IsVisitor = 'had';
      //   const str = JSON.stringify(highCache);
      //   // eslint-disable-next-line
      //   wx.miniProgram.postMessage({ type: 'setCache', data: { 'highCache': str } });
      //   console.log(response);
      // } catch (err) {
      //   console.log(err);
      // } finally {
      //   console.log('结束');
      // }
      // const res = await isRealName();
      if (!res) {
        //   实名弹窗
        this.showModalInfo = {
          isShow: true,
          confirmText: '去实名认证',
          content: '您的账号还没有通过实名认证，绑定一张您本人名下的银行卡才能继续使用该功能',
          link: '/pages/open-account/set-identity/index',
          type: 2,
        };
      } else {
        this.showModalInfo = {};
      }
      return res;
    },

    //   检查是否通过风险测评
    async checkPassRisk() {
      let res = {
        Data: {
          IsSurveyTimeExpire: false,
          IsSurveyed: true,
        },
      };
      try {
        // 动态参数
        const dynamicParams = {
          FundCode: this.fundCode, // 示例动态参数
        };
        const response = await fetchGetLastRiskAnswer(dynamicParams);
        res = response;
        console.log('response, response', response);
      } catch (err) {
        console.log(err);
      } finally {
        console.log('结束');
      }
      // const res = await tradeApiLvsApi.getLastRiskAnswer();
      const {
        IsSurveyTimeExpire,
        IsSurveyed,
      } = res.Data;
      if (!IsSurveyed) {
        this.showModalInfo = {
          isShow: true,
          confirmText: '前往测评',
          content: '您尚未进行风险测评，根据监管要求，查看页面需要您完成风险测评。',
          link: '/pages/risk-assessment/index',
          type: 1,
        };
        return false;
      }
      if (IsSurveyTimeExpire) {
        this.showModalInfo = {
          isShow: true,
          confirmText: '前往测评',
          content: '您的风险测评结果已过期，根据监管要求，查看页面需要您重新完成风险测评。',
          link: '/pages/risk-assessment/index',
          type: 1,
        };
        return false;
      }
      this.showModalInfo = {};
      return true;
    },

    // 检查是否点击过投资者类型弹窗
    async checkClickedInvestorPop() {
      const res = await asyncIsNeedPop();
      if (res) {
        //   投资者类型弹窗
        this.confirmText = '确认符合标准并查看';
      } else {
        this.confirmText = '';
      }
      return !res;
    },
  },
};
</script>

<style scoped>

</style>
